import React, { useEffect, useState } from "react";
import moment from "moment";
import { CustomLabel } from "../../../styled/setting";

const TimeInputField = ({ timeKey, pairKey, isStart, value, onChange }) => {
  const timeString = typeof value[timeKey] === "string" ? value[timeKey] : "";
  const [hour = "", minute = ""] = timeString.split(":");

  const handleInput = (part) => (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 2);
    const newHour = part === "hour" ? val : hour;
    const newMinute = part === "minute" ? val : minute;
    onChange({ ...value, [timeKey]: `${newHour}:${newMinute}` });
  };

  const handleBlur = () => {
    const inputHour = parseInt(hour, 10);
    const inputMinute = parseInt(minute, 10);

    const validHour = isNaN(inputHour) ? 0 : Math.min(Math.max(inputHour, 0), 23);
    const validMinute = isNaN(inputMinute) ? 0 : Math.min(Math.max(inputMinute, 0), 59);

    const currentTime = moment({ hour: validHour, minute: validMinute });
    let formattedCurrent = currentTime.format("HH:mm");

    let pairString = value[pairKey];
    const pairMoment = moment(pairString, "HH:mm", true);

    if (pairMoment.isValid()) {
      const shouldSwap = isStart
        ? currentTime.isAfter(pairMoment)
        : currentTime.isBefore(pairMoment);

      if (shouldSwap) {
        [formattedCurrent, pairString] = [pairString, formattedCurrent];
      }
    }

    onChange({ ...value, [timeKey]: formattedCurrent, [pairKey]: pairString });
  };

  return (
    <div className="timeInputGroup">
      <input
        type="text"
        placeholder="시"
        value={hour}
        onChange={handleInput("hour")}
        onBlur={handleBlur}
        inputMode="numeric"
      />
      :
      <input
        type="text"
        placeholder="분"
        value={minute}
        onChange={handleInput("minute")}
        onBlur={handleBlur}
        inputMode="numeric"
      />
    </div>
  );
};

const TimeInput = ({ label, value, onChange, isClosed }) => {
  const [isFullTime, setIsFullTime] = useState(false);

  useEffect(() => {
    const is24 = value.isOpen && value.openTime === "00:00" && value.closeTime === "00:00";
    setIsFullTime(is24);
  }, [value.openTime, value.closeTime, value.isOpen]);

  const showBreak = value.showBreak ?? false;
  const closed = typeof isClosed === "boolean" ? isClosed : value.isOpen === false;

  const renderTimePair = (startKey, endKey) => (
    <div className="timeField">
      <TimeInputField
        timeKey={startKey}
        pairKey={endKey}
        isStart={true}
        value={value}
        onChange={onChange}
      />
      ~
      <TimeInputField
        timeKey={endKey}
        pairKey={startKey}
        isStart={false}
        value={value}
        onChange={onChange}
      />
    </div>
  );

  const toggleFullTime = () => {
    const next = !isFullTime;
    setIsFullTime(next);

    requestAnimationFrame(() => {
      onChange({
        ...value,
        openTime: next ? "00:00" : "09:00",
        closeTime: next ? "00:00" : "18:00",
      });
    });
  };

  return (
    <div>
      <div className="header">
        <span className="label">{label}</span>
        {!closed && (
          <button
            type="button"
            onClick={toggleFullTime}
            className={isFullTime ? "active" : "inactive"}>
            {isFullTime ? "시간 설정" : "24시간 영업"}
          </button>
        )}
      </div>
      {closed ? (
        <div className="closed">휴무</div>
      ) : (
        <>
          {isFullTime ? (
            <div className="timeField is24Hours">
              <input type="text" value="24시간 운영중" readOnly />
            </div>
          ) : (
            renderTimePair("openTime", "closeTime")
          )}

          {!isFullTime && (
            <>
              <div className="check">
                <CustomLabel>
                  <input
                    type="checkbox"
                    checked={showBreak}
                    onChange={(e) => {
                      const checked = e.target.checked;

                      onChange({
                        ...value,
                        showBreak: checked,
                        breakStartTime: checked ? value.breakStartTime : "",
                        breakEndTime: checked ? value.breakEndTime : "",
                      });
                    }}
                  />
                  <span className="checkmark"></span>
                </CustomLabel>
                <span>휴게시간이 있으신가요?</span>
              </div>
              {showBreak && renderTimePair("breakStartTime", "breakEndTime")}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default TimeInput;
